import { type Actions, ActionType } from './contacts.actions';
import { contactAdapter, initialState, type State } from './contacts.state';

export function contactsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_CONTACTS: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_CONTACTS_SUCCEDED: {
            return contactAdapter.setAll(action.payload.contacts, {
                ...state,
                isLoaded: true,
                isPending: false
            });
        }

        case ActionType.FETCH_CONTACTS_FAILED: {
            return {
                ...state,
                isLoaded: false,
                isPending: false
            };
        }

        case ActionType.CREATE_CONTACT: {
            return contactAdapter.addOne(action.payload.contact, state);
        }

        case ActionType.UPDATE_CONTACT: {
            return contactAdapter.updateOne(
                {
                    id: action.payload.contactId,
                    changes: action.payload.contactUpdate
                },
                state
            );
        }

        case ActionType.DELETE_CONTACT: {
            return contactAdapter.removeOne(action.payload.contactId, state);
        }

        case ActionType.RESET: {
            return { ...initialState };
        }

        default:
            return state;
    }
}
